import { CREATOR_ONBOARDING_PATH } from '@eventbrite/auth-lib';
import {
    checkGate,
    initializeSdk,
    logEvent,
    StatsigUser,
    updateUser,
} from '@eventbrite/statsig';

export const CREATE_APP_PATH = '/create?skipOnboarding=1';
const CREATE_REFERRER = '/create';
const AUTH_SIGNUP_CLICK_BUTTON = 'Signup - Form - Click - Continue Button';
const AUTH_LOGIN_CLICK_BUTTON = 'Login - Form - Click - Login Button';
const SSO_LOGIN_CLICK_BUTTON = 'Login - SSO - Click - SSO Button';

// Use same event name as Heap for consistency
const WEB_LOGIN_SUCCESS = 'WebSignInLoginSuccessful';
const LOGIN_PAGE_VIEW = 'Login - All - View - Page';
export const NO_ONBOARDING_GATE = 'no_onboarding_gate';

let referrer: string;

interface AppProps {
    request: {
        params?: {
            referrer?: string;
        };
    };
}

export const shouldAvoidOnboarding = (): boolean => {
    return checkGate(NO_ONBOARDING_GATE);
};

export interface SignupResponse {
    redirectUrl: string;
    id: string;
}

export const isCreatorRedirect = (url: string) => {
    const decodedUrl = url ? decodeURIComponent(url) : '';

    return (
        CREATOR_ONBOARDING_PATH === decodedUrl ||
        decodedUrl.indexOf(CREATE_REFERRER) === 0
    );
};

export const updateStatsigSession = async (publicId?: string) => {
    if (publicId) {
        try {
            await updateUser({
                user: {
                    userID: publicId,
                    custom: {
                        referrer: referrer,
                    },
                },
            });
            return true;
        } catch (e) {
            return false;
        }
    }
    return false;
};

const getNoOnboardingPath = (url: string) => {
    let result = CREATE_APP_PATH;
    const urlSegments = url.split('?');

    if (urlSegments.length === 2) {
        const queryParams = new URLSearchParams(urlSegments[1]);
        queryParams.forEach((value, key) => {
            result += `&${key}=${value}`;
        });
    }

    return result;
};

export const getRedirectUrl = (redirectUrl: string): string => {
    const url = redirectUrl;

    if (isCreatorRedirect(url)) {
        return shouldAvoidOnboarding() ? getNoOnboardingPath(url) : redirectUrl;
    }

    return redirectUrl;
};

export const trackNewUser = (referrer: string | undefined) => {
    const referrerValue = referrer || '';
    logEvent(AUTH_SIGNUP_CLICK_BUTTON, null, { referrer: referrerValue });
};

export const trackEmailPasswordLogin = (referrer?: string) => {
    const referrerValue = referrer || '';
    logEvent(AUTH_LOGIN_CLICK_BUTTON, null, {
        referrer: referrerValue,
    });
};

export const trackLoginPageView = () => {
    logEvent(LOGIN_PAGE_VIEW);
};

export const trackSSOLogin = (socialProvider: string) => {
    logEvent(SSO_LOGIN_CLICK_BUTTON, null, {
        socialProvider,
    });
};

export const trackLoginSuccessInStatsig = () => {
    logEvent(WEB_LOGIN_SUCCESS);
};

export const getInitialStatsigCustomUserConfig = (
    referrer: string,
): StatsigUser => {
    return {
        custom: {
            referrer: referrer,
        },
    };
};

export const initializeStatsigSdk = async (props: AppProps) => {
    referrer = props.request.params?.referrer || '';
    await initializeSdk({
        user: getInitialStatsigCustomUserConfig(referrer),
    });
};
